import type { InjectionKey } from 'vue';

/** Provided by WorkspacePanelRight: opens the Open in Nanome dialog from anywhere inside the panel. */
export const OPEN_IN_NANOME: InjectionKey<() => void> = Symbol('open-in-nanome');
